import styled from '@emotion/styled';
import { icons } from '@assets/icons';

export const StyledMetatagItemWrap = styled.div`
  position: relative;
  margin-top: 18px;
  border: 1px solid #e0e0e0;
`;
export const StyledMetatagBox = styled.div`
  overflow-y: auto;
  position: relative;
  /* min-width: 1080px; */
  max-height: calc(100vh - 70.1vh);
  padding: 40px;
  background-color: #fff;
  &.add-tag {
    min-height: 310px;
  }

  * {
    box-sizing: border-box;
  }
`;
export const StyledMetatagItem = styled.div`
  position: relative;
  display: block;
  align-items: center;
  width: 100%;
  height: 200px;
  min-width: 1000px;
  margin-top: 20px;
  padding: 40px;
  border: 1px solid #e0e0e0;
  &:after {
    content: '';
    position: absolute;
    top: -1px;
    bottom: -1px;
    left: -1px;
    display: block;
    width: 6px;
    background-color: transparent;
  }
  &:first-of-type {
    margin-top: 0;
  }
  &.report {
    display: flex;
    & > div {
      width: calc((100% - 200px) / 2);
    }
  }

  & .check-input {
    width: 20%;
    min-width: 100px;
  }

  &.disable {
    &:after {
      background-color: #999;
    }
    & .bnt-confirm {
      cursor: not-allowed;
    }
  }

  &.active {
    &:after {
      background-color: #00bf00;
    }
    & .title {
      background-color: #00bf00;
      border-left-color: #7fe200;
    }
    & .bnt-confirm {
      background-color: #00bf00;
      color: #fff;
    }
  }
  &.success {
    &:after {
      background-color: #7fe200;
    }
    & .title {
      background-color: #7fe200;
      border-left-color: #7fe200;
    }
  }
  &.error {
    &:after {
      background-color: #ff4c4c;
    }
    & .value {
      & input {
        border-color: #ff4c4c;
        &:hover {
          border-color: #ff4c4c !important;
        }
      }
      & .error-msg {
        display: block;
        position: absolute;
        bottom: -30px;
        left: 0;
        font-size: 12px;
        color: #ff4c4c;
      }
    }
    & .bnt-confirm {
      cursor: not-allowed;
      background-color: #ff4c4c;
      color: #fff;
    }
  }
`;
export const StyledValue = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: calc((100% - 94px) / 2);
  & .title {
    width: 40%;
    min-width: 146px;
    height: 50px;
    margin-right: 30px;
    padding: 0 30px;
    line-height: 50px;
    border-left: 4px solid #ccc;
    background-color: #999;
    color: #fff;
    & + div {
      position: relative;
      width: 60%;
    }
    & + .sequence-type {
      width: 40%;
    }
    & .error-msg {
      display: none;
    }
  }
  & input[type='text'] {
    min-width: 100px;
    padding-right: 16px;
  }
`;
export const StyledMetatag = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: calc((100% - 94px) / 2);
  margin-right: 30px;
  & .title {
    width: 40%;
    min-width: 146px;
    height: 50px;
    margin-right: 30px;
    padding: 0 30px;
    line-height: 50px;
    border-left: 4px solid #ccc;
    background-color: #999;
    color: #fff;
    & + div {
      width: 60%;
      min-width: 100px;
    }
  }
`;
export const StyledTxtSuccess = styled.p`
  position: absolute;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  width: 146px;
  margin: 0;
  text-align: center;
  cursor: default;
  & span {
    padding-left: 35px;
    font-size: 16px;
    font-weight: bold;
    background: url(${icons.success}) no-repeat left center;
    background-size: 28px 28px;
    color: #00c1ca;
  }
`;
export const StyledConfirmButton = styled.button`
  position: absolute;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  width: 146px;
  height: 36px;
  margin: 0 0 0 auto;
  border-radius: 50px;
  font-size: 14px;
  font-weight: bold;
  background-color: #999;
  color: rgba(255, 255, 255, 0.5);

  &.confirm {
    background-color: #7fe200;
    color: #fff;
  }
  &.warning {
    background-color: #ff4c4c;
    color: #fff;
  }
`;
export const StyledcloseButton = styled.button`
  position: absolute;
  top: -1px;
  right: -1px;
  width: 30px;
  height: 30px;
  border: 1px solid #e0e0e0;
  background: url(${icons.close}) no-repeat center;
  background-size: 24px 24px;
`;
export const StyledMetatagAddButton = styled.button`
  width: 100%;
  height: 40px;
  text-align: center;
  border-top: 1px solid #e0e0e0;
  background-color: #fafafa;
  & span {
    padding-left: 20px;
    background: url(${icons.addInfo_plus}) no-repeat left center;
    background-size: 16px 16px;
    color: #555;
  }
`;
export const StyledSwButtonSection = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 53px;
  & button {
    margin-top: 0;
  }
`;
